export default __webpack_public_path__ + "static/media/policyadmin.7ee8365d.png";